import { Box, Card, CardContent, CardMedia, Stack, Typography } from "@mui/material";
import { Article } from "../../types/Article";
import { useEffect, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { DragHandleRounded, DragIndicatorRounded } from "@mui/icons-material";

export const FeaturedArticleBox = (props: { article: Article }) => {
    const { article } = props;

    const cardHeight = 72;
    const cardWidth = 100;

    let media: JSX.Element;
    if (article.imageUrl.includes("https://lottie.host")) {
        media = <DotLottieReact
            src={article.imageUrl}
            loop
            autoplay
            style={{
                width: "100%",
                height: "100%",
                objectFit: "fill", // Adjust based on your requirement
            }}
        />;
    } else {
        media = <img
            src={article.imageUrl} 
            style={{
                width: "100%",
                height: "100%",
                objectFit: "fill", // Adjust based on your requirement
            }}
        />;
    }

    return (
        <Card key={article.id} sx={{ display: 'flex', height: cardHeight }}>
            <CardMedia component="div" sx={{ width: cardWidth, height: cardHeight }}>
                {media}
            </CardMedia>
            <Box flexGrow={1}>
                <CardContent>
                    <Stack>
                        <Typography variant="body2" noWrap>{article.title}</Typography>
                        <Typography variant="caption">{article.title}</Typography>
                    </Stack>
                </CardContent>
            </Box>
            <DragIndicatorRounded sx={{ alignSelf: "center", cursor: "grab" }} />
        </Card>
    );
};